import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=2109b26a&scoped=true"
import script from "./VerifyUser.vue?vue&type=script&lang=js"
export * from "./VerifyUser.vue?vue&type=script&lang=js"
import style0 from "./VerifyUser.vue?vue&type=style&index=0&id=2109b26a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109b26a",
  null
  
)

/* custom blocks */
import block0 from "./VerifyUser.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports